import { useState, useEffect } from "react";
import { Form } from "antd";
import { useOneButtonStore } from "../../../../store/oneButtonStore";
import { OBDSelect } from "./form-elements";

interface YearlyUsageTabPrams {
    YearlyUsage: any;
    setYearlyUsage: (value: any) => void;
}

export const YearlyUsageTab = ({ YearlyUsage, setYearlyUsage, disabled }: YearlyUsageTabPrams & { disabled?: boolean }) => {
    const theme = useOneButtonStore((s) => s.theme);
    const billMonthOptions = [
        { value: "January", label: "January" },
        { value: "February", label: "February" },
        { value: "March", label: "March" },
        { value: "April", label: "April" },
        { value: "May", label: "May" },
        { value: "June", label: "June" },
        { value: "July", label: "July" },
        { value: "August", label: "August" },
        { value: "September", label: "September" },
        { value: "October", label: "October" },
        { value: "November", label: "November" },
        { value: "December", label: "December" },
    ];

    const [yearlyUsage, setAnnualUsage] = useState(YearlyUsage);

    useEffect(() => {
        if (YearlyUsage == null) return;
        setAnnualUsage(prev => {
            if (prev?.AnnualUsage === YearlyUsage?.AnnualUsage && prev?.ElectricBillMonth === YearlyUsage?.ElectricBillMonth && prev?.avgDailyUsage === YearlyUsage?.avgDailyUsage) return prev;
            return { ...YearlyUsage };
        });
    }, [YearlyUsage]);

    const updateAnnualUsage = (event: any) => {
        const val = event.target.value;
        if (val !== '' && !/^\d*\.?\d*$/.test(val)) {
            return;
        }
        const annualUsageNum = Number(val) || 0;
        const avgDailyUsage = (annualUsageNum / 365).toFixed(2);
        const updatedYearlyUsage = {
            ...YearlyUsage,
            AnnualUsage: val,
            avgDailyUsage: avgDailyUsage
        };
        setYearlyUsage(updatedYearlyUsage);
        setAnnualUsage(updatedYearlyUsage);
    }

    const updateElectricBillMonth = (event: any) => {
        const electricBillMonth = event.target.value;
        const updatedYearlyUsage = {
            ...yearlyUsage,
            ElectricBillMonth: electricBillMonth
        };
        setYearlyUsage(updatedYearlyUsage);
        setAnnualUsage(updatedYearlyUsage);
    }


    return (
        <Form layout="vertical" className="sd-utility-popup__form">
            <div className="sd-utility-popup__field">
                <div className="obd-utility__field">
                    <label className="obd-utility__field-label">Average Daily Usage (in WH)</label>
                    <input
                        type="text"
                        className="obd-utility__input"
                        value={yearlyUsage?.avgDailyUsage}
                        disabled
                    />
                </div>
            </div>
            <div className="sd-utility-popup__field">
                <div className="obd-utility__field">
                    <label className="obd-utility__field-label">Annual Usage (in WH) <span className="required">*</span></label>
                    <input
                        type="text"
                        className="obd-utility__input"
                        value={yearlyUsage?.AnnualUsage}
                        onChange={(e) => updateAnnualUsage(e)}
                        disabled={disabled}
                    />
                    {(() => {
                        const n = Number(yearlyUsage?.AnnualUsage);
                        const invalid = !Number.isFinite(n) || n <= 0;
                        return invalid ? (
                            <span className="validation-message">The Annual Usage is a required field.</span>
                        ) : null;
                    })()}
                </div>
            </div>
            <div className="sd-utility-popup__field">
                <div className="obd-utility__field">
                    <label className="obd-utility__field-label">Bill of Month</label>
                    <OBDSelect
                        className="obd-utility__select"
                        popupClassName={`obd-select-dropdown obd-theme-${theme} obd-utility-details-select-dropdown`}
                        aria-label="Bill month"
                        placeholder="Select..."
                        value={yearlyUsage?.ElectricBillMonth || undefined}
                        options={billMonthOptions}
                        onChange={(value) => updateElectricBillMonth({ target: { value } })}
                        disabled={disabled}
                    />
                </div>
            </div>
        </Form>
    );
};